import { useTranslation } from 'react-i18next';
import React from 'react';

import { useModals } from 'hooks';

import Modal from 'components/Modal/Modal';
import { Box, Button, Image, Text } from 'components/library';
import ContactUsLink from 'components/ContactUsLink';

import alertImage from './img/alert.svg';

const AccountDeleteErrorContainer = () => {
    const { t } = useTranslation();
    const { closeModal } = useModals();

    return (
        <Modal isOpen onClose={closeModal}>
            <Box $paddingTop={20} $paddingBottom={20} $paddingX={16}>
                <Image center maxWidth={46} src={alertImage} alt="sandClock" mb={12} />
                <Text type="h5" bold center mb={24}>
                    {t('account.settings.deleteAccount.successModal.title')}
                </Text>
                <Text type="medium-text" center mb={24}>
                    {t('account.settings.deleteAccount.successModal.subTitle')}
                </Text>
                <a href={process.env.WALKFIT_ONBOARDING}>
                    <Button onClick={closeModal} mb={20} dataLocator="obTakeQiuz">
                        {t('account.settings.deleteAccount.successModal.takeQuiz')}
                    </Button>
                </a>
                <ContactUsLink />
            </Box>
        </Modal>
    );
};

export default AccountDeleteErrorContainer;
